import * as React from "react";
import styled from "styled-components";
// styled-components requires specifying an element type,
// but these styles can apply to multiple elements using the "as" prop.
// https://styled-components.com/docs/api#as-polymorphic-prop
const StyledCopy = styled.span `
    color: ${props => props.color ?? "inherit"};
    font-family: Roboto;
    font-weight: ${props => (props.bold ? 500 : 400)};
`;
const Copy = ({ children, tag = "span", ...props }) => (React.createElement(StyledCopy, { as: tag, ...props }, children));
export default Copy;
